const initState = () => ({
})

export const state = initState
export const getters = {
}

export const mutations = {
}

export const actions = {
  async fetchRegisters({commit}, storeID) {
    if(!storeID || storeID <= 0){
      this.$toast.error('Please select a store first')
      return;
    }

    let registers = []
    try {
      const result = await this.$axios.$get(`/webpos/stores/${storeID}/registers`)

      if (!result || !result.apiMessages || result.apiMessages.hasErrors) {
        this.$toast.error('Error while fetching registers')
      }
      else {
        registers = result.value
      }
    }
    catch {
      this.$toast.error('Error while fetching registers')
    }

    return registers

  },

  async createNewRegisterOperation({commit}, {registerOperation}) {
    try{
      await this.$axios.$post(`/webpos/registers/operations`, registerOperation)
      this.$toast.success('Register operation completed successfully');
      return true
    }
    catch{
      this.$toast.error('Error while adding operation to register')
    }
  },

  async addCashToRegister({commit}, {cashPayment, formatCurrency}) {
    let result = true
    try{
      let response = await this.$axios.$post(`/webpos/registers/register-payment`, cashPayment)
      if(response && !response.hasErrors){
        this.$toast.success(
          this.$i18n.t('pay_in')
            .replace('{amount}', formatCurrency(cashPayment.amount, 2, cashPayment.currencySymbol))
            .replace('{register_name}', cashPayment.registerName)
        )
      }
      else{
        this.$toast.error("Error occured while adding payment to register")
        result = false
      }
    }
    catch(e){
      this.$toast.error('Error while adding payment to register')

      result = false
    }

    return result
  },

}
